import { useEffect, useMemo, useState } from "react";
import { Form, Modal, Typography } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";

import { setRootInit, getUnitsOptions } from "@/api/units";

const { Text } = Typography;

// Окно для редактирования головной организации
const RootUnitModal = ({ visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [units, setUnits] = useState([]);

  const rootUnit = useMemo(() => {
    return units.find((unit) => unit.is_root) || null;
  }, [units]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      const { units } = await getUnitsOptions();
      setUnits(units.filter(({ unit_type }) => unit_type.is_hierarchical));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      await setRootInit(values);

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () =>
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });

  return (
    <Modal
      maskClosable={false}
      title="Установка головной организации"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{}}
        onFinish={handleSave}
      >
        <Text style={{ marginBottom: 15, display: "block" }}>
          Текущая головная организация:{" "}
          {rootUnit ? rootUnit.name : "Не установлена"}
        </Text>

        <Form.Item
          name="uuid"
          label="Выбрать головную организацию"
          rules={[{ required: true, message: "Пожалуйста, заполните поле" }]}
        >
          <CustomSelect
            placeholder="Начните вводить"
            options={units}
            showSearch
            allowClear
            fieldNames={{ value: "uuid", label: "name" }}
            optionFilterProp="name"
          />
        </Form.Item>

        <Text type="warning" style={{ display: "block", marginBottom: 10 }}>
          Внимание! Установка головной организации приведет к изменению
          структуры рабочих групп. Убедитесь, что вы понимаете последствия этого
          действия. Отменить его будет невозможно.
        </Text>
        {error && <Text type="danger">{error}</Text>}
      </Form>
    </Modal>
  );
};

export default RootUnitModal;
